<template>
    <div>
        <b-tab :id="'alt-tab-5'" :active="scorplan" :title="setText('scorr_plan')" v-if="accScorr">
            <b-tabs class="tabs-in-tabs">
                <b-tab :title="setText('expenses')">
                    <expens-table :accessLevels="accessLevelsSP" :userId="userId" @reload-journal="$emit('reload-journal')" :isLoadToJournalEnabled="isLoadToJournalEnabled" />
                </b-tab>
                <b-tab :title="setText('income')" v-if="['uf'].includes(accessLevelsSP.position)">
                    <income-table :accessLevels="accessLevelsSP" :userId="userId" @reload-journal="$emit('reload-journal')" :isLoadToJournalEnabled="isLoadToJournalEnabled" />
                </b-tab>
            </b-tabs>

        </b-tab>
        <b-tab :id="'alt-tab-6'" :active="utochplan" :title="setText('refined_plan')" v-if="accUtoch">
            <b-tabs class="tabs-in-tabs">
                <b-tab :title="setText('expenses')">
                    <alteration-utoch-plan-abp
                        :tab-type="1"
                        :region-base="regionBase"
                        :access-levels="accessLevelsUP"
                        :module-code="mCodeUP"
                        @reload-journal="$emit('reload-journal')"
                        :isLoadToJournalEnabled="isLoadToJournalEnabled"
                    ></alteration-utoch-plan-abp>
                </b-tab>
                <b-tab :title="setText('income')">
                    <alteration-utoch-plan-abp
                        :tab-type="2"
                        :region-base="regionBase"
                        :access-levels="accessLevelsUP"
                        :module-code="mCodeUP"
                        @reload-journal="$emit('reload-journal')"
                        :isLoadToJournalEnabled="isLoadToJournalEnabled"
                    ></alteration-utoch-plan-abp>
                </b-tab>
            </b-tabs>
        </b-tab>
        <b-tab :id="'alt-tab-7'" :active="balans" :title="setText('balance')" v-if="accBalance">
            <balance-table
                :accessLevels="accessLevelsBal"
                :userId="userId"
                :regionBase="regionBase"
                @reload-journal="$emit('reload-journal')"
                :isLoadToJournalEnabled="isLoadToJournalEnabled"
            />
        </b-tab>
    </div>
</template>


<script>
import incomeTable from "@/modules/budget/alteration/form/tabs/components/reportsPlan/incomeTable";
import expensTable from "@/modules/budget/alteration/form/tabs/components/reportsPlan/expensTable";
import balanceTable from "@/modules/budget/alteration/form/tabs/components/reportsPlan/balanceTable";
import AlterationUtochPlanAbp from "@/modules/budget/alteration/form/tabs/components/utochPlan/AlterationUtochPlanAbp";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
export default {
    name: "AlterationReports",
    components: { incomeTable, expensTable, balanceTable, AlterationUtochPlanAbp },
    mixins: [ AlterationI18nMixin ],
    props: ["regionBase", "userId", "accessModules", "isLoadToJournalEnabled"],
    computed: {
        accBalance() {
            return this.accessLevelsBal?.is_in_hierarchy && ['uf'].includes(this.accessLevelsBal.position)
        },
        accScorr() {
            return this.accessLevelsSP?.is_in_hierarchy
        },
        accUtoch() {
            return this.accessLevelsUP?.is_in_hierarchy
        }
    },
    data(){
        return {
            reportTab: 0,
            scorplan: false,
            utochplan: false,
            balans: false,
            mCodeSP: '005.002.004',
            mCodeUP: '005.002.005',
            mCodeBal: '005.002.006',
            accessLevelsSP: {},
            accessLevelsUP: {},
            accessLevelsBal: {}
        }
    },
    created() {
        this.$watch('accessModules', () => {
            this.$nextTick(() => {
                // ScorrPlan
                this.accessLevelsSP = this.accessModules.find(item => item.modules === this.mCodeSP);

                this.$set(this, 'scorplan', this.accessLevelsSP?.active);

                // UtochPlan
                this.accessLevelsUP = this.accessModules.find(item => item.modules === this.mCodeUP);
                this.$set(this, 'utochplan', this.accessLevelsUP?.active);

                // Balance
                this.accessLevelsBal = this.accessModules.find(item => item.modules === this.mCodeBal);

                this.$set(this, 'balans', this.accessLevelsBal?.active);

            });
        });
    },
    async mounted() {},
    methods: { }
}
</script>

<style scoped>

</style>